import { render, staticRenderFns } from "./vconsolelog.vue?vue&type=template&id=2f5fb9b1&scoped=true&"
import script from "./vconsolelog.vue?vue&type=script&lang=js&"
export * from "./vconsolelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5fb9b1",
  null
  
)

export default component.exports